// frontend/src/config/reportRegistry.js

export const reportCategories = [
  "Favorites",
  "Financial & Billing",
  "Team Performance",
  "Audit & Compliance",
  "Project Management"
];

export const reports = [

  // ===============================
  // TEAM PERFORMANCE
  // ===============================

  {
    id: "daily-eod",
    name: "Daily EOD Report",
    description: "Daily end-of-day work log for the logged-in user.",
    category: "Team Performance",
    route: "/reports/daily-eod",
    tags: ["daily", "eod", "work log", "activity"],
    roles: ["ADMIN", "HR", "PROJECT_MANAGER", "USER"],
    format: "table",
    frequency: "daily",
    status: "active"
  },

  {
    id: "effort-summary",
    name: "Effort Summary",
    description: "Total effort logged by date.",
    category: "Team Performance",
    route: "/reports/effort-summary",
    tags: ["effort", "hours", "summary", "time"],
    roles: ["ADMIN", "HR", "PROJECT_MANAGER", "USER"],
    format: "table",
    frequency: "monthly",
    status: "active"
  },

  {
    id: "user-timesheet",
    name: "User Timesheet Summary",
    description: "Detailed effort log including project and work items.",
    category: "Team Performance",
    route: "/reports/timesheet",
    tags: ["time", "effort", "attendance", "hours", "work", "log"],
    roles: ["ADMIN", "HR", "PROJECT_MANAGER", "USER"],
    format: "table",
    frequency: "monthly",
    status: "active"
  },

  {
    id: "project-effort",
    name: "Project Effort Report",
    description: "Total hours logged per project.",
    category: "Team Performance",
    route: "/reports/project-effort",
    tags: ["project", "hours", "effort", "summary"],
    roles: ["ADMIN", "HR", "PROJECT_MANAGER"],
    format: "table",
    frequency: "monthly",
    status: "active"
  },

  {
    id: "project-summary",
    name: "Project Summary Report",
    description: "Overview of projects including total tasks and effort.",
    category: "Project Management",
    route: "/reports/project-summary",
    tags: ["project", "summary", "tasks", "hours"],
    roles: ["ADMIN", "PROJECT_MANAGER"],
    format: "table",
    frequency: "monthly",
    status: "active"
  },

  {
    id: "resource-utilization",
    name: "Resource Utilization Report",
    description: "User utilization percentage and productivity metrics.",
    category: "Team Performance",
    route: "/reports/utilization",
    tags: ["utilization", "productivity", "efficiency", "performance"],
    roles: ["ADMIN", "HR"],
    format: "chart",
    frequency: "monthly",
    status: "inactive"
  },

  {
    id: "task-status",
    name: "Task Status Breakdown",
    description: "Tasks grouped by status (Open, In Progress, Completed).",
    category: "Project Management",
    route: "/reports/task-status",
    tags: ["tasks", "status", "open", "completed"],
    roles: ["ADMIN", "PROJECT_MANAGER"],
    format: "chart",
    frequency: "weekly",
    status: "inactive"
  },

  {
    id: "overdue-tasks",
    name: "Overdue Task Report",
    description: "Tasks past due date requiring attention.",
    category: "Project Management",
    route: "/reports/overdue",
    tags: ["overdue", "deadline", "late", "pending"],
    roles: ["ADMIN", "PROJECT_MANAGER"],
    format: "table",
    frequency: "daily",
    status: "inactive"
  },

  // ===============================
  // FINANCIAL
  // ===============================

  {
    id: "billing-summary",
    name: "Resource Billing Summary",
    description: "Billable hours and revenue projection.",
    category: "Financial & Billing",
    route: "/reports/billing",
    tags: ["invoice", "money", "finance", "rates", "cost", "budget"],
    roles: ["ADMIN", "HR"],
    format: "table",
    frequency: "monthly",
    status: "inactive"
  },

  {
    id: "budget-burn",
    name: "Project Budget Burn",
    description: "Track budget consumption across projects.",
    category: "Financial & Billing",
    route: "/reports/budget-burn",
    tags: ["budget", "burn", "finance", "cost", "money"],
    roles: ["ADMIN"],
    format: "chart",
    frequency: "monthly",
    status: "inactive"
  },

  // ===============================
  // AUDIT
  // ===============================

  {
    id: "approval-log",
    name: "Timesheet Approval Log",
    description: "Audit trail of timesheet approvals.",
    category: "Audit & Compliance",
    route: "/reports/approval-log",
    tags: ["approval", "audit", "history", "compliance"],
    roles: ["ADMIN", "HR"],
    format: "table",
    frequency: "monthly",
    status: "active"
  }

];